import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../../components/common/common-components.module";
import { EditVisitTime } from "./edit-visit-time";

@NgModule({
  declarations: [EditVisitTime],
  imports: [
    IonicPageModule.forChild(EditVisitTime),
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgbModule.forRoot(),
  ],
})
export class EditVisitTimeModule {}



// WEBPACK FOOTER //
// ./src/pages/assessment/visits/edit-visit-time/edit-visit-time.module.ts